module.exports = __webpack_public_path__ + "img/waist.8392b617.png";